// third party imports
import { useNavigate } from "react-router-dom";

// internal rebet imports
import "./stylesUserManagerHeader.css";
import {
  USER_HEADER_TABS,
} from "../../../../utils/Constants";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { AppStrings } from "../../../../utils/constants/AppStrings";
import FeatureFlagGuard from "../../../FeatureFlagGuard/FeatureFlagGuard";
import { TRIVELTA_PRODUCTS } from "../../../../utils/products";
import useIsDevMode from "../../../../hooks/useIsDevMode";

// component imports

// asset imports

const UserManagerHeader = ({ selectedTab, setSelectedTab }) => {
  // non-state variables
  const navigate = useNavigate();
  const isDevMode = useIsDevMode();

  // helper functions
  const handleBackPressed = () => {
    navigate(-1);
  };

  return (
    <div className="user-manager-header-container">
      <div className="back-button-container" onClick={handleBackPressed}>
        <ArrowLeftOutlined className="back-arrow" size={16} />
        <p className="back-text">{AppStrings.BACK_TO_USERS}</p>
      </div>
      <div className="user-manager-header">
        <button
          className={
            selectedTab === USER_HEADER_TABS?.OVERVIEW
              ? "user-manager-header-tab-selected"
              : "user-manager-header-tab"
          }
          onClick={() => setSelectedTab(USER_HEADER_TABS?.OVERVIEW)}
        >
          <p
            className={
              selectedTab === USER_HEADER_TABS?.OVERVIEW
                ? "tab-text-selected"
                : "tab-text"
            }
          >
            {AppStrings.OVERVIEW}
          </p>
        </button>

        <button
          className={
            selectedTab === USER_HEADER_TABS?.TRANSACTIONS
              ? "user-manager-header-tab-selected"
              : "user-manager-header-tab"
          }
          onClick={() => setSelectedTab(USER_HEADER_TABS?.TRANSACTIONS)}
        >
          <p
            className={
              selectedTab === USER_HEADER_TABS?.TRANSACTIONS
                ? "tab-text-selected"
                : "tab-text"
            }
          >
            {AppStrings.TRANSACTIONS}
          </p>
        </button>

        {isDevMode ? (
          <button
            className={
              selectedTab === USER_HEADER_TABS?.PAYMENTS
                ? "user-manager-header-tab-selected"
                : "user-manager-header-tab"
            }
            onClick={() => setSelectedTab(USER_HEADER_TABS?.PAYMENTS)}
          >
            <p
              className={
                selectedTab === USER_HEADER_TABS?.PAYMENTS
                  ? "tab-text-selected"
                  : "tab-text"
              }
            >
              {AppStrings.PAYMENTS}
            </p>
          </button>
        ) : null}

        {/* TODO(PAMENG-1820): drop the `feature` fallback on the 5 guards
            below after rollout. */}
        <FeatureFlagGuard
          product={TRIVELTA_PRODUCTS.SPORTSBOOK}
          feature="sportsbook_v2"
          mode="conditional"
        >
          <button
            className={
              selectedTab === USER_HEADER_TABS?.BETS
                ? "user-manager-header-tab-selected"
                : "user-manager-header-tab"
            }
            onClick={() => setSelectedTab(USER_HEADER_TABS?.BETS)}
          >
            <p
              className={
                selectedTab === USER_HEADER_TABS?.BETS
                  ? "tab-text-selected"
                  : "tab-text"
              }
            >
              {AppStrings.SPORTS_BETS}
            </p>
          </button>
        </FeatureFlagGuard>

        <FeatureFlagGuard
          product={TRIVELTA_PRODUCTS.CASINO}
          feature="casino"
          mode="conditional"
        >
          <button
            className={
              selectedTab === USER_HEADER_TABS?.CASINO_BETS
                ? "user-manager-header-tab-selected"
                : "user-manager-header-tab"
            }
            onClick={() => setSelectedTab(USER_HEADER_TABS?.CASINO_BETS)}
          >
            <p
              className={
                selectedTab === USER_HEADER_TABS?.CASINO_BETS
                  ? "tab-text-selected"
                  : "tab-text"
              }
            >
              {AppStrings.CASINO_BETS}
            </p>
          </button>
        </FeatureFlagGuard>

        <FeatureFlagGuard product={TRIVELTA_PRODUCTS.POKER} feature="poker" mode="conditional">
          <button
            className={
              selectedTab === USER_HEADER_TABS?.POKER_BETS
                ? "user-manager-header-tab-selected"
                : "user-manager-header-tab"
            }
            onClick={() => setSelectedTab(USER_HEADER_TABS?.POKER_BETS)}
          >
            <p
              className={
                selectedTab === USER_HEADER_TABS?.POKER_BETS
                  ? "tab-text-selected"
                  : "tab-text"
              }
            >
              {AppStrings.POKER}
            </p>
          </button>
        </FeatureFlagGuard>

        <FeatureFlagGuard product={TRIVELTA_PRODUCTS.GAME_PASS} feature="gamePass" mode="conditional">
          <button
            className={
              selectedTab === USER_HEADER_TABS?.GAME_PASS
                ? "user-manager-header-tab-selected"
                : "user-manager-header-tab"
            }
            onClick={() => setSelectedTab(USER_HEADER_TABS?.GAME_PASS)}
          >
            <p
              className={
                selectedTab === USER_HEADER_TABS?.GAME_PASS
                  ? "tab-text-selected"
                  : "tab-text"
              }
            >
              {AppStrings.GAME_PASS}
            </p>
          </button>
        </FeatureFlagGuard>

        <FeatureFlagGuard product={TRIVELTA_PRODUCTS.PIKKEM} feature="pikkem" mode="conditional">
          <button
            className={
              selectedTab === USER_HEADER_TABS?.PIKKEM
                ? "user-manager-header-tab-selected"
                : "user-manager-header-tab"
            }
            onClick={() => setSelectedTab(USER_HEADER_TABS?.PIKKEM)}
          >
            <p
              className={
                selectedTab === USER_HEADER_TABS?.PIKKEM
                  ? "tab-text-selected"
                  : "tab-text"
              }
            >
              {AppStrings.PIKKEM}
            </p>
          </button>
        </FeatureFlagGuard>

        {isDevMode ? (
          <button
            className={
              selectedTab === USER_HEADER_TABS?.PROMOTIONS
                ? "user-manager-header-tab-selected"
                : "user-manager-header-tab"
            }
            onClick={() => setSelectedTab(USER_HEADER_TABS?.PROMOTIONS)}
          >
            <p
              className={
                selectedTab === USER_HEADER_TABS?.PROMOTIONS
                  ? "tab-text-selected"
                  : "tab-text"
              }
            >
              {AppStrings.PAM_PROMOTIONS}
            </p>
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default UserManagerHeader;
